import { z } from 'zod';

import { isRole, roleSchema, roleTextMap, roleWeightMap, Role } from 'types/Role';

export const employeeRole = roleSchema;

export type EmployeeRole = Role;

export const isValidRole = (role: string): role is EmployeeRole => {
  return isRole(role);
};

export const employeeSchema = z
  .object({
    id: z.number(),
    first_name: z.string(),
    last_name: z.string().nullish(),
    patronymic: z.string().nullish(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
    blocked: z.boolean(),
    role: employeeRole,
  })
  .transform((raw) => ({
    id: raw.id,
    firstName: raw.first_name,
    lastName: raw.last_name ?? '',
    patronymic: raw.patronymic,
    email: raw.email,
    phone: raw.phone,
    role: raw.role,
    blocked: raw.blocked,
  }));

export const employeesListSchema = z.object({
  items: z.array(employeeSchema),
  total: z.number(),
});

export type EmployeeEntityApi = z.input<typeof employeeSchema>;
export type EmployeeEntity = z.infer<typeof employeeSchema>;

export type EmployeesListEntityApi = z.input<typeof employeesListSchema>;
export type EmployeesListEntity = z.infer<typeof employeesListSchema>;

export { roleTextMap };
export const employeeRoleWeightMap: Record<EmployeeRole, number> = roleWeightMap;
